import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getAllHeroSlides, deleteHeroSlide, updateHeroSlide } from '../api/adminApi';
import { getAssetUrl } from '../../api/client';
import '../adminTheme.css';
import './adminTables.css';

export default function HeroListPage() {
  const { token } = useAuth();
  const [slides, setSlides] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  async function load() {
    setLoading(true);
    setError('');
    try {
      setSlides(await getAllHeroSlides(token));
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function handleDelete(id) {
    if (!window.confirm('Delete this hero slide?')) return;
    try {
      await deleteHeroSlide(token, id);
      load();
    } catch (err) {
      alert(err.message);
    }
  }

  async function handleToggleActive(slide) {
    const formData = new FormData();
    formData.append('isActive', String(!slide.isActive));
    try {
      await updateHeroSlide(token, slide._id, formData);
      load();
    } catch (err) {
      alert(err.message);
    }
  }

  return (
    <div>
      <div className="cs-admin_page_header">
        <h1>Hero Slides</h1>
        <Link to="/admin/hero/new" className="cs-admin_btn cs-admin_btn-primary">
          + Add Slide
        </Link>
      </div>

      {error && <div className="cs-admin_error">{error}</div>}

      {loading ? (
        <p style={{ color: '#999' }}>Loading...</p>
      ) : slides.length === 0 ? (
        <p style={{ color: '#999' }}>No hero slides yet.</p>
      ) : (
        <table className="cs-admin_table">
          <thead>
            <tr>
              <th>Image</th>
              <th>Title</th>
              <th>Link</th>
              <th>Active</th>
              <th>Order</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {slides.map((slide) => (
              <tr key={slide._id}>
                <td>
                  <img src={getAssetUrl(slide.imgUrl)} alt="" className="cs-admin_thumb cs-admin_thumb-wide" />
                </td>
                {/* title supports <br/> the same way the original static showcaseData did -
                    safe here since only an authenticated admin can ever set this value */}
                <td dangerouslySetInnerHTML={{ __html: slide.title }} />
                <td>{slide.href}</td>
                <td>
                  <button className="cs-admin_toggle" onClick={() => handleToggleActive(slide)}>
                    {slide.isActive ? 'Active' : 'Hidden'}
                  </button>
                </td>
                <td>{slide.order}</td>
                <td className="cs-admin_row_actions">
                  <Link to={`/admin/hero/${slide._id}/edit`}>Edit</Link>
                  <button onClick={() => handleDelete(slide._id)} className="cs-admin_link_danger">
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
